import qs from 'qs';
import { newAPI } from '../../../../../../services';

export const createTypePricesLink = async (userId, establishmentId, clientId, params) => {
  const response = await newAPI.put(`/${userId}/establishment/${establishmentId}/clients/${clientId}/type-prices-link`, qs.stringify(params));
  return response.data;
}

export const fetchClient = clientId =>
  newAPI.get(`/clients/${clientId}`).then(response => response.data);